// LIBRARIES
import { Box, ListItem } from "@mui/material";
import { ReactNode, useEffect, useRef, useState } from "react";
import { useBottomScrollListener } from "react-bottom-scroll-listener";
// COMPONENTS
import { List, CircularProgress } from "./listStyle";

// INTERFACES
interface FdListProps {
  onBottomScroll?: Function; // a bottom scroll callback must be provided if there is API pagination
  children?: ReactNode;
  className?: string;
  items: any;
  isLoading?: Boolean;
  noData?: ReactNode | string;
}

const FdList = ({
  items,
  onBottomScroll,
  children,
  className = "",
  isLoading,
  noData = "no data"
}: FdListProps) => {
  // const [loadedItems, setLoadedItems] = useState(
  //   onBottomScroll ? items : items?.slice(0, 50) // initialize the state with all the provided items if API pagination is implemented
  // );
  const [loadedItems, setLoadedItems] = useState<any[]>([]);
  useEffect(() => {
    // update state only when new items are loaded from the API, new items are loaded on bottom scroll
    if (onBottomScroll) {
      setLoadedItems(items);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [items]);
  // build the items list progressively (load only 10 in a row) to avoid the slow rendering of DOM elements
  let scrollRef = useRef<any>();
  scrollRef = useBottomScrollListener(handleBottomScrollEvent, {
    triggerOnNoScroll: false,
    debounce: 200,
  });

  function handleBottomScrollEvent() {
    // load more elements if there is API pagination
    if (onBottomScroll) {
      onBottomScroll();
    }

    // load DOM elements progressively if there is no API pagination or when importing local large CSV files
    if (!onBottomScroll && loadedItems?.length < items?.length) {
      setLoadedItems([
        ...loadedItems,
        ...items?.slice(loadedItems?.length, loadedItems?.length + 50),
      ]);
    }
  }
  return (
    <>
     {!isLoading && items?.length === 0 ? (
        <Box sx={{height:"100%",backgroundColor:"#fff"}}>
          {noData}
        </Box>
      )
      :
    
    <List className={className} ref={scrollRef}>
      {/* list items will render here */}
      {children}
      {/* Loader */}
      {isLoading && (
        <ListItem className="data">
          <CircularProgress />
        </ListItem>
      )}
    </List>
     
      }
    </>
  );
};

export default FdList;
